
const CustomScreens=()=>{
    return <div>hello custom screens</div>
    
}
export default CustomScreens